import { Component, OnInit, Input, EventEmitter, Output, HostBinding } from '@angular/core';
import { Router } from '@angular/router';
import { DropdownItem } from '../../../dynamic-dropdown/dynamic-dropdown.component';
import { ContactItem } from 'src/app/components/user-dashboard/contacts/models/contacts';
// import { SharedContactService } from '../../../../components/user-dashboard/contacts/shared-contact.service'; // Start using parent logic or service

@Component({
  selector: 'app-contacts-list-item',
  templateUrl: './contacts-list-item.component.html',
  styleUrls: ['./contacts-list-item.component.css']
})
export class ContactsListItemComponent implements OnInit {
  @Input() item: ContactItem;
  @Input() miniView: boolean = false;
  @Input() isActive: boolean = false;
  @Output() onDelete = new EventEmitter<ContactItem>();
  @Output() onEdit = new EventEmitter<ContactItem>();

  @HostBinding('style.display') get displayStyle() {
    return this.miniView ? 'block' : 'table-row';
  }

  onClickRouter: string | any[];
  dropdownItems: DropdownItem[] = [];

  constructor(private router: Router) { }

  ngOnInit() {
    this.onClickRouter = ['/dashboard', 'contact', this.item.id, 'view'];
    this.generateDropdown();
  }

  generateDropdown() {
    this.dropdownItems = [
      {
        label: 'View Profile',
        iconSvg: 'assets/images/svg/system/preview.svg',
        colorSet: 'gray-700',
        colorSetHover: 'primary',
        routerLink: this.onClickRouter
      },
      {
        label: 'Edit Contact',
        iconSvg: 'assets/images/svg/system/edit.svg',
        colorSet: 'gray-700',
        colorSetHover: 'primary',
        action: () => {
          this.onEdit.emit(this.item);
        }
      },
      undefined,
      {
        label: 'Delete Contact',
        iconSvg: 'assets/images/svg/system/trash.svg',
        colorSet: 'danger',
        colorSetHover: 'danger',
        hidden: this.item.type === 'owner',
        action: () => {
          this.onDelete.emit(this.item);
        }
      }
    ];
  }
}

